'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsAdmin = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getIsAdmin = exports.getIsAdmin = (0, _getIn2.default)(['clientData', 'isAdmin']);


//////////////////
// WEBPACK FOOTER
// ./js/selectors/clientSelectors/getIsAdmin.js
// module id = 198
// module chunks = 2 3